module.exports = __webpack_public_path__ + "img/bau-logo-for-light.7c18a2b3.png";